import Validation from '../lib/validation'
import { roles } from '../config'

function validate(data, action, role, platform = 'both') {
  const validator = new Validation(data)
  if (action === 'create') {

    validator.isRequired('driver', 'Není zvolen řidič.')
    validator.isRequired('location', 'Zvolte lokaci.')
    validator.isRequired('courseType', 'Zvolte typ akce/kurzu.')

  } else {

    if (platform === 'web') {
        validator.isRequired('location', 'Zvolte lokaci.')
        validator.isRequired('courseType', 'Zvolte typ akce/kurzu.')
        validator.isRequired('testedAt', 'Vyberte datum testu.')
    }

    if ([roles.PC_OPERATOR, roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1) {
      if (data.trafficRulesTestPoints) {
        validator.isRequired('trafficRulesTestPoints', 'Počet dosažených bodů musí být od 0 do 50')
      }
    }
    if ([roles.INSTRUCTOR, roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1) {
      if (platform === 'web' && data.closedByInstructor) {
        validator.isIntegerBiggerThan('trafficRulesPoints', 1, 'Hodnocení pravidel provozu není úplně vyplněno. Zkontrolujte číselné hodnocení.')
        validator.isIntegerBiggerThan('defensiveDrivingPoints', 1, 'Hodnocení defenzivního způsobu jízdy není úplně vyplněno. Zkontrolujte číselné hodnocení.')
        validator.isIntegerBiggerThan('drivingTechniquePoints', 1, 'Hodnocení techniky jízdy není úplně vyplněno. Zkontrolujte číselné hodnocení.')
        validator.isIntegerBiggerThan('drivingEconomyPoints', 1, 'Hodnocení ekonomiky jízdy není úplně vyplněno. Zkontrolujte číselné hodnocení.')
      }
      if (data.drivingLicenceExpireDate) {
        validator.isDate('drivingLicenceExpireDate', 'Expirace ŘP musí být datum.')
      }
      if (data.experienceYearsCount) {
        validator.isPositiveInteger('experienceYearsCount', 'Počet let musí být kladné číslo')
      }
      if (data.workExperienceYearsCount) {
        validator.isPositiveInteger('workExperienceYearsCount', 'Počet let musí být kladné číslo')
      }
      if (data.causedCrashesCount) {
        validator.isPositiveInteger('causedCrashesCount', 'Počet nehod musí být kladné číslo')
      }
      if (data.notCausedCrashesCount) {
        validator.isPositiveInteger('notCausedCrashesCount', 'Počet nehod musí být kladné číslo')
      }
      if (data.trafficRulesPoints) {
        validator.isPoints('trafficRulesPoints', 'Počet bodů musí být od 1 do 9')
      }
      if (data.defensiveDrivingPoints) {
        validator.isPoints('defensiveDrivingPoints', 'Počet bodů musí být od 1 do 9')
      }
      if (data.drivingTechniquePoints) {
        validator.isPoints('drivingTechniquePoints', 'Počet bodů musí být od 1 do 9')
      }
      if (data.drivingEconomyPoints) {
        validator.isPoints('drivingEconomyPoints', 'Počet bodů musí být od 1 do 9')
      }
      if (platform === 'web' && data.closedByInstructor) {
        validator.isLength('driverSummary', 10, 'Není vyplněno shrnutí - profil řidiče. Shrnutí musí mít alespoň 10 znaků.')
      }
    }
    if ([roles.SUPERVISOR].indexOf(role) !== -1) {
      if (platform === 'web' && data.closedBySupervisor) {
        validator.isRequired('result', 'Není vybrán výrok.')
      }
      if (platform === 'web' && data.safetyFactor) {
        validator.isDecimalPoints('safetyFactor', 'Počet bodů musí být od 1 do 9')
      }
    }
  }
  return validator.validate()
}

export const validateCreate = (data) => validate(data, 'create')
export const validateUpdate = (data, role) => validate(data, 'update', role)
export const validateUpdatePCOperator = (data) => validate(data, 'update', roles.PC_OPERATOR)
export const validateUpdateInstructor = (data) => validate(data, 'update', roles.INSTRUCTOR)
export const validateUpdateInstructorWeb = (data) => validate(data, 'update', roles.INSTRUCTOR, 'web')
export const validateUpdatePsychologist = (data) => validate(data, 'update', roles.PSYCHOLOGIST)
export const validateUpdateAdmin = (data) => validate(data, 'update', roles.ADMIN)
export const validateUpdateAdminWeb = (data) => validate(data, 'update', roles.ADMIN, 'web')
export const validateUpdateSupervisor = (data) => validate(data, 'update', roles.SUPERVISOR)
export const validateUpdateSupervisorWeb = (data) => validate(data, 'update', roles.SUPERVISOR, 'web')

export default validate



// WEBPACK FOOTER //
// ./src/common/results/validations.js